import TableAction from "components/TableAction";
import PropTypes from "prop-types";
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PreviewIcon from "@mui/icons-material/Preview";
import GenericMoreButton from "components/GenericMoreButton";
import { useAppContextController } from "context/AppContext";
import { useCallback, useMemo } from "react";
import { isEmpty, isEqual } from "lodash";
import fetchCustomers from "api/companies/fetchCustomers";
import { useQuery } from "react-query";
import { AccountBalance } from "@mui/icons-material";

const InvoiceTableActions = ({
  setNavigateUrl,
  setNavigateUrlToScreen,
  row,
  setActionSelected,
  setFilters,
  // setOpen,
  // setEventPreview,
  // setJobPreview,
  // getAndSetFullEvent,
  // getAndSetFullJob,
  getAndSetFullInvoice,
  setInvoiceForPreview,
  setInvoiceForDeletion,
  setInvoiceForVoiding,
  // openTimeModal,
}) => {
  const { userType, company, currentLoggedUser } = useAppContextController();

  const isCompany = company?.companyType === "Company";
  const onClickHandler = useCallback(
    (action, e) => {
      e.stopPropagation();

      if (action === "invoicepreview") {
        setInvoiceForPreview(row);
        return;
      }
      if (action === "invoicevoid") {
        setInvoiceForVoiding(row);
        return;
      }
      if (action === "invoicedelete") {
        setInvoiceForDeletion(row);
        return;
      }

      const nodes = new URL(window.location).pathname.split("/");
      const baseRoute = `/invoices/${row?._id}`;

      setFilters((prev) => {
        const newFilters = { ...prev };
        // if (newFilters.timeFrame) delete newFilters.timeFrame;
        return { ...newFilters, _id: row._id };
      });

      getAndSetFullInvoice(row._id);
      setNavigateUrl(`${baseRoute}/action/${action}`);
    },
    [
      getAndSetFullInvoice,
      row,
      setFilters,
      setInvoiceForDeletion,
      setInvoiceForPreview,
      setInvoiceForVoiding,
      setNavigateUrl,
    ]
  );

  const filteredActions = useMemo(
    () => [
      {
        color: "info",
        icon: "info",
        clickAction: (e) => onClickHandler("invoiceinfo", e),
        tooltip: "Invoice Info",
      },
      {
        color: "info",
        icon: "visibility",
        clickAction: (e) => onClickHandler("invoicepreview", e),
        tooltip: "Preview Invoice",
      },
      {
        color: "error",
        icon: "block",
        clickAction: (e) => onClickHandler("invoicevoid", e),
        tooltip: "Void Invoice",
        disabled: row?.status === "Void",
      },
      {
        color: "error",
        icon: "delete",
        clickAction: (e) => onClickHandler("invoicedelete", e),
        tooltip: "Delete Invoice",
      },
    ],
    [onClickHandler, row?.status]
  );

  if (filteredActions.length <= 4) {
    return (
      <span>
        {filteredActions.map((prop) => (
          <TableAction {...prop} key={prop.tooltip} />
        ))}
      </span>
    );
  }

  return (
    <span>
      {filteredActions.slice(0, 4).map((prop) => (
        <TableAction {...prop} key={prop.tooltip} />
      ))}
      <GenericMoreButton buttons={filteredActions.slice(1)} />
    </span>
  );
};

export default InvoiceTableActions;

InvoiceTableActions.defaultProps = {
  eventUrl: "",
};

// Typechecking props for the TableAction
InvoiceTableActions.propTypes = {
  eventUrl: PropTypes.string,
  // children: PropTypes.node.isRequired,
};
